import type { TAppState } from '../../types/appState';
import type { IChatProfile } from '../../types/chatProfile';
import { currentOpenChatIDSelector } from '../currentOpenChatIDSelector';
import { userProfileByChatIdSelector } from './userProfileByChatIdSelector';

export const userProfileSelector = (state: TAppState): IChatProfile | null => {
  const chatId = currentOpenChatIDSelector(state);

  if (!chatId) {
    return null;
  }

  return userProfileByChatIdSelector(state, chatId);
};
